<template>
  <div>
    <main class="landing login" v-cloak>
      <nav class="navbar navbar-expand-lg navbar-dark bg-transparent">
        <div class="container">
          <a class="navbar-brand" href="/">
            <img
              :src="$store.state.campaign.logo"
              class="d-inline-block align-top"
              :alt="$store.state.campaign.name"
            />
          </a>
        </div>
      </nav>
      <div
        class="locale-changer"
        v-if="this.$store.state.campaign.accept_languages.length > 1"
      >
        <div class="l-login__locale__wrapper">
          <div
            class="l-login__navbar__locale primary-bg"
            @click="localeOpen = !localeOpen"
          >
            <span class="l-login__navbar__locale__text">{{
              locale.toUpperCase()
            }}</span>
            <i
              class="fas fa-chevron-down l-login__navbar__locale__icon"
              :class="{ localeOpen: !localeOpen }"
            ></i>
          </div>
          <div
            class="l-login__navbar__locale--expanded"
            :class="{
              'd-none l-login__navbar__locale--expanded': !localeOpen
            }"
          >
            <div
              class="l-login__dropdown__item"
              v-for="lang in locales"
              :key="lang"
              @click="handleChangeLocale(lang)"
            >
              {{ lang.toUpperCase() }}
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-12 header-block">
            <div class="CTA">
              <h1 class="h5 text-primary mb-5">
                {{ $store.state.campaign.name }}
              </h1>
            </div>
          </div>
          <div class="col-12 header-block" v-if="showReset">
            <div class="card">
              <div class="card-body" style="padding-bottom:1rem">
                <div class="CTA" style="min-height:0;">
                  <h2 class="h1 display-4">{{ $t("Reset password") }}</h2>
                  <h5
                    class="mb-0"
                    v-if="$store.state.campaign.idm_phone_login_enabled"
                  >
                    {{
                      $t(
                        "Utilizza il tuo indirizzo email o il tuo numero di cellulare per ripristinare la password"
                      )
                    }}
                  </h5>
                  <h5 class="mb-0" v-else>
                    {{
                      $t(
                        "Utilizza il tuo indirizzo email per ripristinare la password"
                      )
                    }}
                  </h5>
                </div>
                <form
                  class="mt-5 row"
                  style="padding-left:15px;padding-right:15px;"
                  v-cloak
                  data-vv-scope="resetForm"
                  @submit.prevent="validateForm('resetForm', sendResetCode)"
                >
                  <template>
                    <div class="form-group col-12">
                      <input
                        id="reset_credential"
                        type="text"
                        class="form-control"
                        name="credential"
                        v-validate="'required|phoneOrEmail'"
                        required
                        v-model="reset.credential"
                        v-if="$store.state.campaign.idm_phone_login_enabled"
                        :placeholder="$t('Email / Cellulare')"
                      />
                      <input
                        id="reset_credential"
                        type="text"
                        class="form-control"
                        name="credential"
                        v-validate="'required|email'"
                        required
                        v-model="reset.credential"
                        v-else
                        :placeholder="$t('Email')"
                      />
                      <label
                        for="reset_credential"
                        v-if="$store.state.campaign.idm_phone_login_enabled"
                        class="h5"
                        >{{ $t("Email / Cellulare") }}</label
                      >
                      <label for="reset_credential" v-else class="h5">{{
                        $t("Email")
                      }}</label>

                      <span
                        class="invalid-feedback"
                        style="position: absolute;bottom: 0;"
                      ></span>
                    </div>
                  </template>
                  <div class="row col-12" style="margin-top:89px;">
                    <div class="text-left col-6 p-0" style="line-height:48px">
                      <a
                        href="#"
                        class="btn-not-spinner"
                        @click="showReset = false"
                        >{{ $t("Torna alla login") }}</a
                      >
                    </div>

                    <div class="form-group text-right col-6 p-0">
                      <button type="submit" class="btn btn-primary btn-lg">
                        {{ $t("Procedi") }}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col-12 header-block" v-if="showResetWithCode">
            <div class="card">
              <div class="card-body" style="padding-bottom:1rem">
                <div class="CTA" style="min-height:0;">
                  <h2 class="h1 display-4">{{ $t("Reset password") }}</h2>
                  <h5 class="mb-0">
                    {{
                      $t(
                        "Utilizza il tuo indirizzo email o il tuo numero di cellulare per ripristinare la password"
                      )
                    }}
                  </h5>
                </div>
                <form
                  class="mt-5 row"
                  style="padding-left:15px;padding-right:15px;"
                  v-cloak
                  data-vv-scope="resetWithCodeForm"
                  @submit.prevent="
                    validateForm('resetWithCodeForm', resetPassword)
                  "
                >
                  <template>
                    <div class="form-group col-12">
                      <input
                        id="reset_code"
                        type="text"
                        class="form-control"
                        name="reset_code"
                        v-validate="'required'"
                        required
                        v-model="reset.reset_code"
                        :placeholder="$t('Codice di conferma')"
                      />
                      <label for="reset_code" class="h5">{{
                        $t("Codice di conferma")
                      }}</label>
                      <span
                        v-show="errors.has('resetWithCodeForm.reset_code')"
                        class="invalid-feedback"
                        style="position: relative; bottom: 0px; padding-bottom: 10px;"
                      >
                        <strong>{{
                          errors.first("resetWithCodeForm.reset_code")
                        }}</strong>
                      </span>
                    </div>

                    <div class="form-group col-12">
                      <input
                        id="password"
                        type="password"
                        class="form-control"
                        name="password"
                        v-validate="'required'"
                        minlength="8"
                        required
                        v-model="reset.password"
                        :placeholder="$t('Password')"
                      />
                      <label for="password" class="h5">{{
                        $t("Password")
                      }}</label>
                      <span
                        v-show="errors.has('resetWithCodeForm.password')"
                        class="invalid-feedback"
                        style="position: relative; bottom: 0px; padding-bottom: 10px;"
                      >
                        <strong>{{
                          errors.first("resetWithCodeForm.password")
                        }}</strong>
                      </span>
                    </div>

                    <div class="form-group col-12">
                      <input
                        id="password_confirmation"
                        type="password"
                        class="form-control"
                        name="password_confirmation"
                        v-validate="{ is: reset.password }"
                        minlength="8"
                        required
                        v-model="reset.password_confirmation"
                        :placeholder="$t('Conferma Password')"
                      />
                      <label for="password_confirmation" class="h5">{{
                        $t("Confirm Password")
                      }}</label>
                      <span
                        v-show="
                          errors.has('resetWithCodeForm.password_confirmation')
                        "
                        class="invalid-feedback"
                        style="position: relative; bottom: 0px; padding-bottom: 10px;"
                      >
                        <strong>{{
                          errors.first(
                            "resetWithCodeForm.password_confirmation"
                          )
                        }}</strong>
                      </span>

                      <span
                        class="invalid-feedback"
                        style="position: absolute;bottom: 0;"
                      ></span>
                    </div>
                  </template>
                  <div class="row col-12" style="margin-top:89px;">
                    <div class="text-left col-6 p-0" style="line-height:48px">
                      <a
                        href="#"
                        class="btn-not-spinner"
                        @click="showResetWithCode = false"
                        >{{ $t("Torna alla login") }}</a
                      >
                    </div>

                    <div class="form-group text-right col-6 p-0">
                      <button type="submit" class="btn btn-primary btn-lg">
                        {{ $t("Procedi") }}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div
            class="col-12 col-lg-6 header-block"
            :style="{
              display:
                (($mq === 'sm' || $mq === 'md') &&
                  currentDisplayIfNotDesktop === 'login') ||
                ($mq !== 'sm' && $mq !== 'md')
                  ? 'block'
                  : 'none'
            }"
            v-if="!showReset && !showConfirmation && !showResetWithCode"
          >
            <div class="card">
              <div
                class="card-body"
                style="padding-bottom:1rem"
                :style="{ padding: $mq !== 'sm' ? '3rem' : '1rem' }"
              >
                <div class="CTA" style="min-height:0;">
                  <h2 class="h1 display-4">{{ $t("Login") }}</h2>
                  <h5 class="mb-0">
                    {{
                      $t(
                        "Usa il tuo indirizzo email o il tuo numero di cellulare per accedere"
                      )
                    }}
                  </h5>
                </div>
                <div
                  :class="{ 'mt-5': $mq !== 'sm' }"
                  style="padding-top:70px;"
                >
                  <form
                    data-vv-scope="loginForm"
                    @submit.prevent="validateForm('loginForm', login)"
                  >
                    <div class="form-group">
                      <input
                        id="credentials"
                        type="text"
                        class="form-control"
                        name="credentials"
                        v-validate="'required|phoneOrEmail'"
                        ref="credentials"
                        autofocus
                        v-model="signin.credential"
                        :placeholder="$t('E-Mail')"
                        v-if="$store.state.campaign.idm_phone_login_enabled"
                      />
                      <input
                        id="credentials"
                        type="text"
                        class="form-control"
                        name="credentials"
                        v-validate="'required|email'"
                        ref="credentials"
                        autofocus
                        v-model="signin.credential"
                        :placeholder="$t('E-Mail')"
                        v-else
                      />
                      <label
                        for="credentials"
                        v-if="$store.state.campaign.idm_phone_login_enabled"
                        class="h5"
                        >{{ $t("Email / Cellulare") }}</label
                      >
                      <label for="credentials" v-else class="h5">{{
                        $t("Email")
                      }}</label>

                      <span
                        v-show="errors.has('loginForm.credentials')"
                        class="invalid-feedback"
                        style="position: relative; bottom: 0px; padding-bottom: 10px;"
                      >
                        <strong>{{
                          errors.first("loginForm.credentials")
                        }}</strong>
                      </span>
                    </div>

                    <div class="form-group">
                      <input
                        id="password"
                        type="password"
                        class="form-control $errors->has('password') ? ' is-invalid' : '' }}"
                        ref="password"
                        name="password"
                        v-model="signin.password"
                        v-validate="'required'"
                        :placeholder="$t('Password')"
                      />
                      <label for="password" class="h5">{{
                        $t("Password")
                      }}</label>
                      <span
                        v-show="errors.has('loginForm.password')"
                        class="invalid-feedback"
                        style="position: relative; bottom: 0px; padding-bottom: 10px;"
                      >
                        <strong>{{
                          errors.first("loginForm.password")
                        }}</strong>
                      </span>
                    </div>
                    <div
                      class="row"
                      :style="{
                        'margin-top':
                          $mq !== 'sm' && $mq !== 'md' ? '89px' : '0'
                      }"
                    >
                      <div
                        class="col-12 col-lg-6 text-center text-lg-left"
                        style="line-height:48px"
                      >
                        <a
                          href="#"
                          class="btn-not-spinner"
                          @click="showReset = true"
                          >{{ $t("Password dimenticata?") }}</a
                        >
                      </div>

                      <div
                        class="form-group col-12 col-lg-6 text-center text-lg-right"
                        style="padding-top: 0"
                      >
                        <button class="btn btn-primary btn-lg">
                          {{ $t("Login") }}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div
              v-if="
                ($mq === 'sm' || $mq === 'md') &&
                  currentDisplayIfNotDesktop === 'login'
              "
              class="text-center"
            >
              <a
                href="#"
                @click="currentDisplayIfNotDesktop = 'register'"
                class="btn-not-spinner"
                >{{ $t("Non hai un account? Registrati") }}</a
              >
            </div>
          </div>
          <div
            class="col-12 header-block"
            :class="!showConfirmation ? 'col-lg-6 ' : ''"
            :style="{
              display:
                (($mq === 'sm' || $mq === 'md') &&
                  currentDisplayIfNotDesktop === 'register') ||
                ($mq !== 'sm' &&
                  $mq !== 'md' &&
                  currentDisplayIfNotDesktop !== 'register') ||
                (($mq === 'sm' || $mq === 'md') &&
                  currentDisplayIfNotDesktop === 'confirmation')
                  ? 'block'
                  : 'none'
            }"
            v-if="!showReset && !showResetWithCode"
          >
            <div class="register">
              <div
                class="card-body"
                :style="{ padding: $mq !== 'sm' ? '3rem' : '1rem' }"
              >
                <template v-if="!showConfirmation">
                  <div class="CTA" style="min-height:0">
                    <h2 class="h1 display-4">
                      {{ $t("Non hai un account") }}
                      {{ $store.state.campaign.name }} ?
                    </h2>
                    <h5 class="mb-0">{{ $t("Registrati") }}</h5>
                  </div>
                  <form
                    class="mt-5 row"
                    style="padding-left:15px;padding-right:15px;"
                    data-vv-scope="registerForm"
                    @submit.prevent="validateForm('registerForm', register)"
                    v-cloak
                  >
                    <div class="col-12 col-lg-6 p-0 pr-lg-1">
                      <div class="form-group">
                        <input
                          id="first_name"
                          type="text"
                          class="form-control"
                          v-model="signup.first_name"
                          :class="{
                            'is-invalid': errors.has('registerForm.first_name')
                          }"
                          v-validate="'required'"
                          data-vv-as="Name"
                          name="first_name"
                          :placeholder="$t('Nome')"
                        />
                        <label for="first_name" class="h5">{{
                          $t("Nome")
                        }}</label>
                        <span
                          v-show="errors.has('registerForm.first_name')"
                          class="invalid-feedback"
                          style="position: relative; bottom: 0px; padding-bottom: 10px;"
                        >
                          <strong>{{
                            errors.first("registerForm.first_name")
                          }}</strong>
                        </span>
                      </div>
                    </div>
                    <div class="col-12 col-lg-6 p-0 pl-lg-1">
                      <div class="form-group">
                        <input
                          id="last_name"
                          type="text"
                          class="form-control"
                          v-model="signup.last_name"
                          :class="{
                            'is-invalid': errors.has('registerForm.last_name')
                          }"
                          name="last_name"
                          data-vv-as="Surname"
                          v-validate="'required'"
                          :placeholder="$t('Cognome')"
                        />
                        <label for="last_name" class="h5">{{
                          $t("Cognome")
                        }}</label>
                        <span
                          v-show="errors.has('registerForm.last_name')"
                          class="invalid-feedback"
                          style="position: relative; bottom: 0px; padding-bottom: 10px;"
                        >
                          <strong>{{
                            errors.first("registerForm.last_name")
                          }}</strong>
                        </span>
                      </div>
                    </div>
                    <div class="form-group col-12">
                      <input
                        id="register_credential"
                        type="text"
                        class="form-control"
                        name="register_credential"
                        v-model="signup.credential"
                        value
                        data-vv-as="Email/Mobile"
                        v-validate="'required|phoneOrEmail'"
                        :placeholder="$t('Email / Cellulare')"
                        v-if="$store.state.campaign.idm_phone_login_enabled"
                      />
                      <input
                        id="register_credential"
                        type="text"
                        class="form-control"
                        name="register_credential"
                        v-model="signup.credential"
                        value
                        data-vv-as="Email"
                        v-validate="'required|email'"
                        :placeholder="$t('Email')"
                        v-else
                      />
                      <label
                        for="register_credential"
                        v-if="$store.state.campaign.idm_phone_login_enabled"
                        class="h5"
                        >{{ $t("Email / Cellulare") }}</label
                      >
                      <label for="register_credential" v-else class="h5">{{
                        $t("Email")
                      }}</label>
                      <span
                        v-show="errors.has('registerForm.register_credential')"
                        class="invalid-feedback"
                        style="position: relative; bottom: 0px; padding-bottom: 10px;"
                      >
                        <strong>{{
                          errors.first("registerForm.register_credential")
                        }}</strong>
                      </span>
                    </div>
                    <div class="form-group col-12">
                      <input
                        id="register_password"
                        type="password"
                        minlength="8"
                        class="form-control"
                        pattern=".{6,}"
                        name="register_password"
                        ref="register_password"
                        v-model="signup.password"
                        v-validate="'required'"
                        :placeholder="$t('Password')"
                      />
                      <label for="register_password" class="h5"
                        >{{ $t("Password") }}
                        {{ $t("almeno 8 caratteri") }}</label
                      >
                      <span
                        v-show="errors.has('registerForm.register_password')"
                        class="invalid-feedback"
                        style="position: relative; bottom: 0px; padding-bottom: 10px;"
                      >
                        <strong>{{
                          errors.first("registerForm.register_password")
                        }}</strong>
                      </span>
                    </div>
                    <div class="form-group col-12">
                      <input
                        id="register_password_confirmation"
                        type="password"
                        class="form-control $errors->has('password_confirmation') ? ' is-invalid' : '' }}"
                        pattern=".{6,}"
                        name="register_password_confirmation"
                        v-model="signup.password_confirmation"
                        v-validate="'required|confirmed:register_password'"
                        :placeholder="$t('Conferma Password')"
                      />
                      <label for="register_password_confirmation" class="h5">{{
                        $t("Ripeti password")
                      }}</label>
                      <span
                        v-show="
                          errors.has(
                            'registerForm.register_password_confirmation'
                          )
                        "
                        class="invalid-feedback"
                        style="position: relative; bottom: 0px; padding-bottom: 10px;"
                      >
                        <strong
                          v-show="
                            errors.has(
                              'registerForm.register_password_confirmation'
                            )
                          "
                          >{{ $t("Le password devono coincidere") }}</strong
                        >
                      </span>
                    </div>
                    <div class="col-12 p-0">
                      <div class="form-check c-registration-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          name="tos"
                          id="tos"
                          value="true"
                          v-model="signup.tos"
                          v-validate="'required'"
                        />
                        <label class="form-check-label" for="tos">
                          {{ $t("Ho preso visione, compreso e accetto i") }}
                          <a
                            href="/public/tos"
                            class="btn-not-spinner"
                            target="_blank"
                            >{{ $t("Termini di Servizio") }}</a
                          >
                        </label>
                        <span
                          v-show="errors.has('registerForm.tos')"
                          class="invalid-feedback"
                          style="position: relative; bottom: 0px; padding-bottom: 10px;"
                        >
                          <strong>{{
                            errors.first("registerForm.tos")
                          }}</strong>
                        </span>
                      </div>
                      <div class="form-check c-registration-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          name="privacy"
                          id="privacy"
                          ref="privacy"
                          value="true"
                          v-model="signup.privacy"
                          v-validate="'required'"
                        />
                        <label class="form-check-label" for="privacy">{{
                          $t("Accetto l'informativa sulla privacy")
                        }}</label>
                        <span
                          v-show="errors.has('registerForm.privacy')"
                          class="invalid-feedback"
                          style="position: relative; bottom: 0px; padding-bottom: 10px;"
                        >
                          <strong>{{
                            errors.first("registerForm.privacy")
                          }}</strong>
                        </span>
                      </div>
                      <div class="form-check c-registration-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          name="marketing"
                          id="marketing"
                          v-model="signup.marketing"
                          value="true"
                        />
                        <label class="form-check-label" for="marketing">{{
                          $t(
                            "Desidero ricevere informazioni realtive ad iniziative di marketing"
                          )
                        }}</label>
                      </div>
                      <div class="form-check c-registration-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          name="profilation"
                          id="profilation"
                          v-model="signup.profilation"
                          value="true"
                        />
                        <label class="form-check-label" for="profilation">{{
                          $t("Acconsento alla profilazione delle mie abitudini")
                        }}</label>
                      </div>
                      <div class="form-check c-registration-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          name="third"
                          id="third"
                          v-model="signup.third"
                          value="true"
                        />
                        <label class="form-check-label" for="third">{{
                          $t(
                            "Desidero ricevere informazioni relative ad iniziative di marketing di terze parti"
                          )
                        }}</label>
                      </div>
                      <div class="form-check c-registration-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          name="third_profilation"
                          v-model="signup.third_profilation"
                          id="third_profilation"
                          value="true"
                        />
                        <label
                          class="form-check-label"
                          for="third_profilation"
                          >{{
                            $t(
                              "Acconsento alla profilazione delle mie abitudini da terze parti"
                            )
                          }}</label
                        >
                      </div>
                    </div>
                    <div
                      class="form-group col-12 text-right"
                      :class="{
                        'text-right': $mq !== 'sm',
                        'text-center': $mq === 'sm'
                      }"
                    >
                      <button class="btn btn-primary btn-lg">
                        {{ $t("Registrati") }}
                      </button>
                    </div>
                  </form>
                </template>
                <template v-else>
                  <div class="CTA" style="min-height:0">
                    <h2 class="h1 display-4">
                      {{ $t("Verifica del nuovo account") }}
                    </h2>
                    <h5 class="mb-0" v-if="confirmationType == 'mobile'">
                      {{
                        $t(
                          "Ti abbiamo inviato un SMS con il codice per la verifica del numero"
                        )
                      }}
                      <br />
                      <strong x-ms-format-detection="none">{{
                        confirmationAddress
                      }}</strong>
                    </h5>
                    <h5 class="mb-0" v-else>
                      {{
                        $t(
                          "Ti abbiamo inviato una email con il codice per la verifica dell'indirizzo"
                        )
                      }}
                      <br />
                      <strong x-ms-format-detection="none">{{
                        confirmationAddress
                      }}</strong>
                    </h5>
                  </div>
                  <form
                    class="mt-5 row"
                    style="padding-left:15px;padding-right:15px;"
                    data-vv-scope="confirmationForm"
                    @submit.prevent="validateForm('confirmationForm', verify)"
                    v-cloak
                  >
                    <div class="form-group col-12">
                      <input
                        id="confirmation"
                        type="text"
                        class="form-control $errors->has('confirmation') ? ' is-invalid' : '' }}"
                        name="confirmation"
                        required
                        :placeholder="$t('Codice di conferma')"
                        v-validate="'required'"
                        v-model="confirmationCode"
                        maxlength="5"
                      />
                      <label for="confirmation" class="h5">{{
                        $t("Codice di conferma")
                      }}</label>
                    </div>
                    <div
                      class="row"
                      style="width:100%"
                      :style="{
                        'margin-top':
                          $mq !== 'sm' && $mq !== 'md' ? '89px' : '0'
                      }"
                    >
                      <div
                        class="col-12 col-lg-6 text-center text-lg-left"
                        style="line-height:48px"
                      >
                        <small>{{ $t("Didn't receive the code?") }}</small>
                        <a
                          class="c-form-actions__link btn-not-spinner"
                          href="#"
                          @click="resendVerifyCode"
                          >{{ $t("Reinvia") }}</a
                        >
                      </div>
                      <div
                        class="form-group col-12 col-lg-6 text-center text-lg-right"
                        style="padding-top: 0"
                      >
                        <button class="btn btn-primary btn-lg">
                          {{ $t("Conferma") }}
                        </button>
                      </div>
                    </div>
                  </form>
                </template>
                <div
                  v-if="
                    ($mq === 'sm' || $mq === 'md') &&
                      currentDisplayIfNotDesktop === 'register'
                  "
                  class="text-center mt-5"
                >
                  <a
                    href="#"
                    @click="currentDisplayIfNotDesktop = 'login'"
                    class="btn-not-spinner"
                  >
                    {{ $t("Ho già un account") }}
                    <br />
                    {{ $t("Accedi") }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import parseDomain from "parse-domain";
import { getLocale, changeLocale } from "@/i18n.js";
export default {
  name: "Login",
  data: function() {
    return {
      signin: {
        credential: null,
        password: null
      },
      signup: {
        credential: null,
        password: null,
        password_confirmation: null,
        first_name: null,
        last_name: null,
        tos: false,
        privacy: false,
        profilation: false,
        marketing: false,
        third: false,
        third_profilation: false
      },
      reset: {
        credential: null,
        reset_code: null,
        password: null,
        confirmation_password: null
      },
      currentDisplayIfNotDesktop: "login",
      showReset: false,
      showConfirmation: false,
      showResetWithCode: false,
      confirmationUserId: null,
      confirmationType: null,
      confirmationAddress: null,
      confirmationCode: null,
      resetUserId: null,
      locale: getLocale(),
      locales: this.generateLocales(),
      localeOpen: false
    };
  },
  methods: {
    login() {
      this.$store.commit("showSpinner");
      this.$http
        .post(
          "/api/v1/campaigns/" + this.$store.state.campaign.id + "/users/login",
          this.signin
        )
        .then(response => {
          localStorage.setItem("token", response.data.data.token.access_token);
          this.$store.state.authorization.access_token =
            response.data.data.token.access_token;
          this.$http.defaults.headers.common["Authorization"] =
            "Bearer " + response.data.data.token.access_token;
          this.$http.defaults.headers["Authorization"] =
            "Bearer " + response.data.data.token.access_token;
          this.$store.state.authorization.expires_in =
            response.data.data.token.expires_in;
          this.$store.commit("hideSpinner");
          this.$store.dispatch("getUserInfo").then(response => {
            this.pushDeviceInfo();
            this.$router.push({ name: "dashboard" });
          });
        })
        .catch(error => {
          let errorResponse = error.response;
          switch (errorResponse.status) {
            case 422:
              this.$store.commit("pushMessage", {
                type: "waiting",
                title: this.$i18n.t("Dati non validi"),
                text: this.$i18n.t("Riprovare per favore")
              });
              break;
            case 406:
              if (this.$store.state.campaign.idm_external_verify) {
                this.$store.commit("pushMessage", {
                  type: "waiting",
                  title: this.$i18n.t("Aspetta!"),
                  text: this.$i18n.t(
                    "Controlla la tua email per verificare il tuo account"
                  )
                });
              } else {
                this.currentDisplayIfNotDesktop = "confirmation";
                this.showConfirmation = true;
                this.confirmationUserId = errorResponse.data.meta.userId;
                this.confirmationType =
                  errorResponse.data.meta.confirmationType;
                this.confirmationAddress =
                  errorResponse.data.meta.confirmationAddress;
              }
              break;
            case 401:
              this.$store.commit("pushMessage", {
                type: "waiting",
                title: this.$i18n.t("Password non valida"),
                text: this.$i18n.t("Riprovare per favore")
              });
              break;
            case 404:
              this.$store.commit("pushMessage", {
                type: "waiting",
                title: this.$i18n.t("Utente non valido"),
                text: this.$i18n.t("Riprovare per favore")
              });
              break;
            default:
              this.$store.commit("pushMessage", {
                type: "waiting",
                title: this.$i18n.t("Errore")
              });
          }
          this.$store.commit("hideSpinner");
        });
    },
    register() {
      this.$store.commit("showSpinner");
      this.$http
        .post(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/users/register",
          {
            ...this.signup,
            ...{
              mgm: Cookies.get("mgm"),
              mgm_code: Cookies.get("mgm_code")
            }
          }
        )
        .then(response => {
          const parsedDomain = parseDomain(window.location.hostname);
          if (parsedDomain) {
            Cookies.remove("mgm", {
              domain: "." + parsedDomain.domain + "." + parsedDomain.tld
            });
          }
          this.confirmationUserId = response.data.data.user_id;
          this.confirmationType = response.data.data.confirmation_type;
          this.confirmationAddress = response.data.data.confirmation_address;

          if (this.$store.state.campaign.idm_external_verify) {
            this.$store.commit("pushMessage", {
              type: "success",
              title: "Success!",
              text: this.$i18n.t("Check your email to verify your account")
            });
          } else {
            this.currentDisplayIfNotDesktop = "confirmation";
            this.showConfirmation = true;
          }
          this.$store.commit("hideSpinner");
        })
        .catch(error => {
          this.$store.commit("hideSpinner");
          let errorStatus = _.get(error, "response.status");
          if (errorStatus === 409) {
            this.$store.commit("pushMessage", {
              type: "waiting",
              title: this.$i18n.t("L'utente è già registrato")
            });
          } else {
            this.$store.commit("pushMessage", {
              type: "waiting",
              title: this.$i18n.t("Error")
            });
          }
        });
    },
    verify() {
      this.$store.commit("showSpinner");
      this.$http
        .post(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/users/" +
            this.confirmationUserId +
            "/verify",
          {
            confirmation_code: this.confirmationCode,
            confirmation_type: this.confirmationType
          }
        )
        .then(response => {
          this.$store.state.authorization.access_token =
            response.data.data.token.access_token;
          localStorage.setItem(
            "token",
            this.$store.state.authorization.access_token
          );
          this.$http.defaults.headers.common["Authorization"] =
            "Bearer " + response.data.data.token.access_token;
          this.$http.defaults.headers["Authorization"] =
            "Bearer " + response.data.data.token.access_token;
          this.$store.state.authorization.expires_in =
            response.data.data.token.expires_in;
          this.$store.commit("hideSpinner");
          this.pushDeviceInfo();
          this.$router.push({ name: "dashboard" });
        })
        .catch(error => {
          this.$store.commit("hideSpinner");
        });
    },
    sendResetCode() {
      this.$store.commit("showSpinner");
      this.$http
        .post(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/users/sendResetCode",
          this.reset
        )
        .then(response => {
          this.resetUserId = response.data.data.user_id;
          this.$store.commit("hideSpinner");
          this.showReset = false;
          if (this.$store.state.campaign.idm_external_reset) {
            this.$store.commit("pushMessage", {
              type: "success",
              title: "Success!",
              text: this.$i18n.t("Check your email to reset your password")
            });
          } else {
            this.showResetWithCode = true;
          }
        })
        .catch(error => {
          let errorResponse = error.response;
          switch (errorResponse.status) {
            case 404:
              this.$store.commit("pushMessage", {
                type: "waiting",
                title: "No user found",
                text:
                  "No user with the specified data was found. Please check if you have done social authentication."
              });
              break;
            default:
              this.$store.commit("pushMessage", {
                type: "waiting",
                title: "Error occurred",
                text: "Please retry"
              });
          }
          this.$store.commit("hideSpinner");
        });
    },
    resetPassword() {
      this.$store.commit("showSpinner");
      this.$http
        .post(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/users/" +
            this.resetUserId +
            "/reset",
          this.reset
        )
        .then(response => {
          this.$store.state.authorization.access_token =
            response.data.data.token.access_token;
          localStorage.setItem(
            "token",
            this.$store.state.authorization.access_token
          );
          this.$http.defaults.headers.common["Authorization"] =
            "Bearer " + response.data.data.token.access_token;
          this.$http.defaults.headers["Authorization"] =
            "Bearer " + response.data.data.token.access_token;
          this.$store.state.authorization.expires_in =
            response.data.data.token.expires_in;
          this.showResetWithCode = false;
          this.$store.commit("hideSpinner");
          this.pushDeviceInfo();
          this.$router.push({ name: "dashboard" });
        })
        .catch(error => {
          this.showResetWithCode = false;
          this.$store.commit("hideSpinner");
        });
    },
    resendVerifyCode() {
      this.$store.commit("showSpinner");
      this.$http
        .post(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/users/" +
            this.confirmationUserId +
            "/resendVerify",
          {
            confirmation_address: this.confirmationAddress,
            confirmation_type: this.confirmationType
          }
        )
        .then(response => {
          this.$store.commit("hideSpinner");
        })
        .catch(error => {
          this.showResetWithCode = false;
          this.$store.commit("hideSpinner");
        });
    },
    generateLocales() {
      const activeLocale = getLocale();
      this.locale = activeLocale;
      const locales = this.$store.state.campaign.accept_languages;
      return locales.filter(item => item != activeLocale);
    },
    async handleChangeLocale(locale) {
      this.locale = locale;
      const locales = this.$store.state.campaign.accept_languages;
      this.locales = locales.filter(item => item != locale);
      this.localeOpen = !this.localeOpen;
      await changeLocale(locale);
    }
  }
};
</script>
<style lang="scss">
.form-group {
  height: auto;
  min-height: 55px;
  padding-top: 36px;
  margin-top: 10px;
}

.c-registration-check {
  margin: 0.75rem 0;
  display: flex;
  padding: 0;
  flex-wrap: wrap;
}
.c-registration-check input {
  margin: 0;
  top: 0.2rem;
}
.c-registration-check label {
  padding-left: 1.5rem;
}
.with-errors {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
  font-weight: bolder;
}
.form-group.has-error {
  padding-left: 0px;
}
.form-group.has-error > .form-control {
  border-bottom: 1px solid #dc3545;
}
.invalid-feedback {
  display: inherit !important;
}

main h5 {
  line-height: inherit !important;
}
.locale-changer {
  position: absolute;
  top: 40px;
  right: 40px;
  z-index: 9999;
}
.l-login__navbar__locale {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-right: 1rem;
  padding: 0rem 1rem;
  border-radius: 25px;
  // background-color: #ff276f;
  color: white;
  width: 4rem;
  margin-bottom: 0.3rem;
  cursor: pointer;
  position: relative;
}
.l-login__navbar__locale__text {
  margin-right: 0.3rem;
}
.l-login__navbar__locale__icon {
  transition: transform 0.3s;
  transform: rotate(180deg);
}
.l-login__locale__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.l-login__navbar__locale--expanded {
  transition: height 0.5 transform 0.5s;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 30px;
}
.localeOpen {
  transition: transform 0.3s;
  transform: rotate(360deg);
}
.l-login__dropdown__item {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-right: 1rem;
  padding: 0rem 1rem;
  border-radius: 25px;
  background-color: rgba(255, 255, 255, 0.8);
  color: black;
  width: 4rem;
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
}
.l-login__dropdown__item:hover {
  background-color: white;
}
</style>
